import { useEffect, useRef } from 'react'

const LAYOUT_SETTLE_MS = 100

export function useResetZoomAfterLayoutChange(
  trigger: boolean,
  handleResetZoom: () => void
): void {
  const previousTrigger = useRef(trigger)
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (previousTrigger.current === trigger) {
      return
    }

    previousTrigger.current = trigger
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          handleResetZoom()
        })
      })
    }, LAYOUT_SETTLE_MS)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [handleResetZoom, trigger])
}
